var exports = {
  "root": "x1cb7f6e3--173b7d--root",
  "phone": "x1cb7f6e3--173b7d--phone",
  "up-block": "x1cb7f6e3--173b7d--up-block",
  "down-block": "x1cb7f6e3--173b7d--down-block",
  "down-block-content": "x1cb7f6e3--173b7d--down-block-content",
  "text-segment": "x1cb7f6e3--173b7d--text-segment",
  "text-segment-title": "x1cb7f6e3--173b7d--text-segment-title",
  "text-segment-description": "x1cb7f6e3--173b7d--text-segment-description",
  "gray": "x1cb7f6e3--173b7d--gray",
};

module.exports = exports;
